import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Row } from 'reactstrap';
import { startInterval } from '../auth/validate-session';
import { getSites } from '../actions/sites';
import { checkIfLoggedIn } from '../actions/auth';

import getCarriers from '../actions/carriers';
import Sidebar from './nav/sidebar';
import MainDash from './main-dash';
import Profile from './profile';
import Analytics from './analytics';
import Admin from './user-admin';
import BatchUpload from './batch-upload';
import Translations from './translations';
import Agencies from './agencies';
import Campaigns from './campaigns';
import Records from './records';
import Sites from './sites';
import Logos from './logos';
import RTS from './rts';
import ProtectedRoute from './common/ProtectedRoute';
import Leads from './leads';

// Standalone pages
import ExportEnrollment from './user-admin/user-details/leads/enrollments/Export';

class Dashboard extends React.PureComponent {
  componentDidMount() {
    document.body.className = 'bg-light';

    // Rehydrate the carrier cache.
    getCarriers();

    // Retrieve sites.
    getSites();

    // Ensure sessions don't go stale and linger.
    startInterval();

    // redirect to login page if not logged in
    checkIfLoggedIn();
  }

  render() {
    return (
      <div className="container-fluid bg-light">
        <ProtectedRoute>
          <Row style={{ width: '97%' }}>
            <Sidebar />
            <Routes>
              <Route path="/main" element={<MainDash />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/analytics/*" element={<Analytics />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/batch" element={<BatchUpload />} />
              <Route path="/translations/*" element={<Translations />} />
              <Route path="/agencies" element={<Agencies />} />
              <Route path="/campaigns" element={<Campaigns />} />
              <Route path="/records" element={<Records />} />
              <Route path="/sites" element={<Sites />} />
              <Route path="/logos" element={<Logos />} />
              <Route path="/leads" element={<Leads />} />
              <Route path="/rts/*" element={<RTS />} />
              <Route path="/quotes/export/:quoteID" element={<ExportEnrollment />} />
            </Routes>
          </Row>
        </ProtectedRoute>
      </div>
    );
  }
}

export default Dashboard;
